import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index";
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';

@Component({})
export default class ProductListComponent extends mixins(BaseComponent) {


    async created() {
        

        this.setLoading();
        await store.dispatch.auth.loadUser();
        this.setLoaded();
      
        // let query = new URLSearchParams(window.location.search);
        // const listname = query.get('listname');
        // if(listname)
        // {
        //     document.getElementById('orderinglistheadername').innerHTML = listname;
        // }
    }
}

Vue.component('product-list', ProductListComponent);